export class EtapaOcorrencia {
  id: number;
  descricao: string;
  ativo: number;
  idSetor: number;
  nomeSetor: string;
  idTipoOcorrencia: number;
  nomeTipo: string;
  enviarEmail: boolean;
  idTemplateEmail: number;
  tempoEstimado?: number;
}
